import { buildLdContext } from 'mission-control-common-components';
import { useEffect } from 'react';

import { isSameLDContext } from '../../utils/launchDarkly/isSameLDContext';
import { setLDClient } from '../../utils/launchDarkly/ldClient';

// CRITICAL: Must use require() not import - tslint breaks for launch-darkly-react-client-sdk
// DO NOT CONVERT TO IMPORT STATEMENT
// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
const { useLDClient } = require('launchdarkly-react-client-sdk');

const LDClientBridge = (): null => {
  const client = useLDClient();

  useEffect(() => {
    setLDClient(client);

    if (client) {
      const idToken = window.localStorage.getItem('id_token');
      const nextContext = buildLdContext(idToken ?? undefined);

      if (!isSameLDContext(client.getContext(), nextContext)) {
        client.identify(nextContext).catch(() => {
          // Identify failures are non-fatal; the client continues using the previous context
          // and bootstrapped flags remain available for this session.
        });
      }
    }

    return () => {
      setLDClient(undefined);
    };
  }, [client]);

  return null;
};

export default LDClientBridge;
